/**
 * ナビゲーションアイコンマップ
 *
 * Home画面とQuickNavで共有するアイコン定義
 */

import {
  Bell,
  BookMarked,
  Bot,
  ChartNoAxesCombined,
  Download,
  Dumbbell,
  Gauge,
  HardDrive,
  Headphones,
  Landmark,
  ListTodo,
  Luggage,
  Music,
  Music4,
  NotebookPen,
  ReceiptText,
  Route,
  SearchCheck,
  Stamp,
  Tv,
  UtensilsCrossed,
  Video,
} from 'lucide-react'
import { ComponentType, ReactNode } from 'react'

import {
  ArchiveIcon,
  EnglishIcon,
  FodIcon,
  LineIcon,
  NHIcon,
  OreillyIcon,
  TranslateIcon,
  TverIcon,
  XIcon,
  XUserIcon,
  YoutubeIcon,
  ZozoIcon,
} from '@/components/ui/icons'
import { PATHS } from '@/routes/paths'

export type NavIconComponent = ComponentType | (() => ReactNode)

/** フォルダにまとめる対象パス（hasFullAccess時） */
export const FOLDER_PATHS = [
  '/p?domain=monsnode',
  '/p?domain=x',
  '/p?domain=zozo',
  '/p?domain=miss',
  '/p?domain=nh',
  '/p?domain=line',
  '/p?domain=tver',
  '/p?domain=fod',
  '/p?domain=abema',
  '/p?domain=oreilly',
  '/p?domain=archive',
  '/p?domain=local',
  '/p?domain=audiobook',
  PATHS.CUSTOM_VIDEO,
  PATHS.CUSTOM_MUSIC,
  PATHS.OFFLINE_PRODUCTS,
]

/** 「英語」フォルダにまとめる対象パス */
export const ENGLISH_PATHS = ['/p?domain=english', PATHS.GRAMMAR_CHECK, PATHS.FLASHCARD.REVIEW]

/** パスとアイコンのマッピング（pages.yaml のパス形式に合わせる） */
export const NAV_ICON_MAP: Record<string, NavIconComponent> = {
  // ドメイン別コンテンツページ（クエリパラメータ形式）
  '/p?domain=monsnode': XIcon,
  '/p?domain=x': XUserIcon,
  '/p?domain=zozo': ZozoIcon,
  '/p?domain=miss': () => <Video size={50} color="white" />,
  '/p?domain=nh': NHIcon,
  '/p?domain=line': LineIcon,
  '/p?domain=tver': TverIcon,
  '/p?domain=fod': FodIcon,
  '/p?domain=abema': () => <Tv size={50} color="#28d97a" />,
  '/p?domain=oreilly': OreillyIcon,
  '/p?domain=archive': ArchiveIcon,
  '/p?domain=local': () => <HardDrive size={50} color="white" />,
  '/p?domain=audiobook': () => <Headphones size={50} color="white" />,
  '/p?domain=english': EnglishIcon,
  // 機能ページ
  [PATHS.ACTIVITY]: () => <ChartNoAxesCombined size={50} color="white" />,
  [PATHS.CUSTOM_VIDEO]: YoutubeIcon,
  [PATHS.CUSTOM_MUSIC]: () => <Music size={50} color="white" />,
  [PATHS.MUSIC.LIBRARY]: () => <Music4 size={50} color="#fa243c" />,
  [PATHS.GRAMMAR_CHECK]: TranslateIcon,
  [PATHS.OFFLINE_PRODUCTS]: () => <Download size={50} color="white" />,
  [PATHS.WORKOUT.HOME]: () => <Dumbbell size={50} color="white" />,
  [PATHS.NUTRITION.HOME]: () => <UtensilsCrossed size={50} color="white" />,
  [PATHS.TODO.HOME]: () => <ListTodo size={50} color="white" />,
  [PATHS.FLASHCARD.REVIEW]: () => <BookMarked size={50} color="white" />,
  [PATHS.MEMO.LIST]: () => <NotebookPen size={50} color="white" />,
  [PATHS.LIBRARY.SEARCH]: () => <Landmark size={50} color="white" />,
  [PATHS.RECEIPTS.LIST]: () => <ReceiptText size={50} color="white" />,
  [PATHS.ROUTE_PLANS.LIST]: () => <Route size={50} color="white" />,
  [PATHS.RALLIES.LIST]: () => <Stamp size={50} color="white" />,
  [PATHS.TRIPS.LIST]: () => <Luggage size={50} color="white" />,
  [PATHS.CHECK]: () => <SearchCheck size={50} color="white" />,
  [PATHS.SETTINGS.API_USAGE]: () => <Gauge size={50} color="white" />,
  [PATHS.SETTINGS.AI_USAGES]: () => <Bot size={50} color="white" />,
  [PATHS.NOTIFICATIONS]: () => <Bell size={50} color="white" />,
}
